import Logo from "./Images/BaraLogo.png";
import About from "./Images/businessmen-reflection 1.png";
import Vision_img from "./Images/vissionLat.png";
import Service_icon from "./Images/service.svg";
import misa_icon from "./Images/misaLc.png";
import Choose from "./Images/choose.png";
import Activity from "./Images/activity.svg";
import Ar_group from "./Images/al group.png";
import Semaka from "./Images/Semaka logo 1.png";
import Dsi from "./Images/DSI Logo 1.png";
import Sc from "./Images/SC Logo 1.png";
import Rating from "./Images/Star.svg";
import History from "./Images/about-history.png";
import Blog1 from "./Images/blog1.png";
import Blog2 from "./Images/blog2.png";
import Blog3 from "./Images/blog3.png";
import ReviewImg from "./Images/reviewimg.png";
import Ibrahim from "./Images/ibrahim.png";
import Jameel from "./Images/jameell.png";
import Khalid from "./Images/khalid.png";
import like from "./Images/like.svg";
import Hero from "./Images/1 Hero Section.png";
import Choose_content from "./Images/Fun Fact.png";
import buisiness from "./Images/business.svg"
import document from "./Images/document.svg"
import legal1 from "./Images/legalSup.svg"
import legal2 from "./Images/legal2.svg"
import submission from "./Images/submission.svg"
import visa from "./Images/visa.svg"
import up from "./Images/up.svg"
import leftRR from "./Images/leftbb.svg"
import rightRR from "./Images/rightbb.svg"
import invest from "./Images/invest.png"
import invest2 from "./Images/Ahsa.webp"
import riyadh from "./Images/RIYADH.webp"
import diriyah from "./Images/DIRIYAH.webp"
import Makkah from "./Images/Makkah.webp"
import Madinah from "./Images/Madinah.webp"
import AlAhsa from "./Images/Ahsa.webp"
import Jeddah from "./Images/Jeddah.webp"
import Dammam from "./Images/DAMMAM.webp"
import Abha from "./Images/Abha.webp"
import Nexus from "./Images/Nexus.jpg"
import millionero from "./Images/millionero.jpg"
import Metalok from "./Images/Metalok.jpg"
import arraham from "./Images/arraham.png"


export const assets = {
  leftRR,
  rightRR,
  up,
  visa,
  submission,
  legal2,
  legal1,
  document,
  buisiness,
  Logo,
  About,
  Vision_img,
  Rating,
  Service_icon,
  misa_icon,
  Choose,
  Activity,
  Ar_group,
  Semaka,
  Dsi,
  Sc,
  History,
  ReviewImg,
  Blog1,
  Blog2,
  Blog3,
  Ibrahim,
  Jameel,
  Khalid,
  like,
  Hero,
  Choose_content,
  Abha,
  Dammam,
  Jeddah,
  AlAhsa,
  Madinah,
  Makkah,
  diriyah,
  riyadh,
  invest2,
  invest,
  Nexus,
  millionero,
  Metalok,
  arraham
};

